import {
  ComponentFactoryResolver,
  Injectable,
  Injector,
  StaticProvider,
} from '@angular/core'
import {
  BasePanelComponent,
  LayoutContainer,
  PanelConfig,
} from '@helios/panel-base'
import { ComponentContainer } from 'golden-layout'

/**
 * Manages how panels are registered into GoldenLayout
 */
@Injectable({
  providedIn: 'root',
})
export class LayoutManagerService {
  private readonly panelMap = new Map<string, PanelConfig>()

  constructor(
    private readonly componentFactoryResolver: ComponentFactoryResolver,
  ) {}

  /**
   * Registers a new Angular Panel for use within GoldenLayout.
   */
  setPanels(panels: PanelConfig[]) {
    this.panelMap.clear()
    for (const panel of panels) {
      this.panelMap.set(panel.key, panel)
    }
  }

  /**
   * Create a panel component from a GoldenLayout PanelConfig.
   *
   * @param panelKey Key value of the panel. This is used to look up the component that needs to be created
   * @param container
   * @returns
   */
  createPanelComponent(panelKey: string, container: ComponentContainer) {
    const panel = this.panelMap.get(panelKey)
    if (panel === undefined || panel.hasAccess !== true) {
      throw new Error('Unknown component type')
    } else {
      const provider: StaticProvider = {
        provide: LayoutContainer,
        useValue: container,
      }
      const injector = Injector.create({
        providers: [provider],
      })
      const componentFactoryRef =
        this.componentFactoryResolver.resolveComponentFactory<BasePanelComponent>(
          panel.panelComponent,
        )
      return componentFactoryRef.create(injector)
    }
  }
}
